import { useEffect } from 'react'
import { useAuthState } from './useAuth'
import { logDeviceInfoToFirestore } from '@/lib/deviceLogging'

/**
 * Hook to log device info to Firestore when user is authenticated
 * Should be called once on app startup in a top-level component (e.g., App.tsx)
 */
export function useDeviceInfoLogging(): void {
  const { user } = useAuthState()

  useEffect(() => {
    if (user?.uid) {
      // Log device info only once per user session
      logDeviceInfoToFirestore(user.uid).catch((error) => {
        console.error('[useDeviceInfoLogging] Error logging device info:', error)
      })
    }
  }, [user?.uid]) // Only run when user ID changes
}

